/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
import { CanvasId } from "../../../commons/types/CanvasId";
import { CanvasAreaType } from "../../types/CanvasAreaType";
import { CanvasAreaPosition } from "../../types/CanvasAreaPosition";
import { CanvasAreaVisibility } from "../../types/CanvasAreaVisibility";
import { CanvasAreaLayout } from "../../types/CanvasAreaLayout";
import { CanvasAreaId } from "../../../commons/types/CanvasAreaId";
export const CreateCanvasAreaRequest = core.serialization.object({
    canvasId: CanvasId,
    type: CanvasAreaType,
    position: CanvasAreaPosition,
    visibility: CanvasAreaVisibility.optional(),
    layout: CanvasAreaLayout.optional(),
    overlay: core.serialization.any().optional(),
    config: core.serialization.any().optional(),
    metadata: core.serialization.any().optional(),
    parentId: CanvasAreaId.optional(),
});
